import React, { useEffect, useState } from "react";
import CancelOrder from "./CancelOrder";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import BookingDetails from "./BookingDetails";
import { profileAction } from "../../../redux/action";
import { formatTextCapitalize, getUser } from "../../../constant/utils";
import { setBookingDataResponse } from "../../../redux/checkout/reducer";
import { ROUTE } from "../../../route/Route";
import { useHistory, useLocation } from "react-router-dom";
import CancelMessage from "./CancelMeassge";
import { Email_BASE_URL } from "../../../redux/common/url";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import Loader from "react-loader-spinner";
import { cartListResponse } from "../../../redux/profile/reducer";
import RefundDetails from "./RefundDetails";
const MyOrder = () => {
  const dispatch = useDispatch();
  const USER: any = getUser();
  const history = useHistory();
  const { state } = useLocation<any>();
  const [open, setOpen] = useState<boolean>(false);
  const [notification, setNotification] = useState<boolean>(false);
  const [openDetail, setOpenDetail] = useState<boolean>(false);
  const [openRefundDetail, setOpenRefundDetail] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<any>("");
  const [openCancelMsg, setOpenCancelMsg] = useState<boolean>(false);
  const [editData, setEditData] = useState<any>({});
  const [bookingEditLoading, setBookingEditLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const commonLoading: any = useSelector((state: any) => (state.common.loader ? state.common.loader : false));
  // const [loading, setLoading] = useState(false);
  const itemsPerPage = 30; // Adjust as needed
  const orderList = useSelector((state: any) => state?.profile?.orderList || []);
  const totalOrder = useSelector((state: any) => state?.profile?.totalOrderList || []);
  // console.log(totalOrder, "totlorder");
  const actionLoading: boolean = useSelector((state: any) => state.profile.actionLoading || false);
  const historyListLoading: boolean = useSelector((state: any) => state.profile.historyListLoading || false);
  const handleOpenCancel = (data: any) => {
    setEditData(data);
    setOpen(true);
  };
  const handleClose = () => {
    setEditData({});
    setOpen(false);
  };
  const handleOpenDetail = (data: any) => {
    dispatch(
      profileAction.bookingDetailsAction(
        {
          CrmBookingId: data?.CrmData?.id,
          BookingId: data?.id,
        },
        () => {
          setOpenDetail(true);
        }
      )
    );
  };

  const handleRefundDetailopen = (id: any) => {
    setSelectedId(id);
    setOpenRefundDetail(true);
  };
  const handleRefundDetailClose = () => {
    setSelectedId("");
    setOpenRefundDetail(false);
  };
  const handleDetailClose = () => {
    setEditData({});
    setOpenDetail(false);
  };
  const handleCancelMsgClose = () => {
    setEditData({});
    setOpenCancelMsg(false);
  };
  const fetchNotifications = () => {
    const fetchSMS = fetch(`${Email_BASE_URL}/cronjob/notifications/sms`, {
      mode: "no-cors",
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("SMS Data:", data);
      });

    const fetchEmail = fetch(`${Email_BASE_URL}/cronjob/notifications/email`, {
      mode: "no-cors",
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Email Data:", data);
      });

    Promise.all([fetchSMS, fetchEmail])
      .then(() => console.log("Both fetch requests completed"))
      .catch((error) => console.error("Error in one or both fetch requests:", error));
  };
  useEffect(() => {
    if (state?.bookingId && orderList) {
      setEditData(orderList?.find((ele: any) => ele?.id == state?.bookingId) || {});
      setOpenDetail(true);
    }
    return () => {
      window.history.replaceState({}, "");
    };
  }, [orderList, state?.bookingId]);

  const handleSubmit = (data: any) => {
    let refund: any = editData?.advance_paid;
    if (
      editData?.id &&
      editData?.payment_txn_id &&
      (editData?.payment_type == "online" || editData?.payment_type == "others") &&
      refund > 0
    ) {
      let payload = {
        PId: editData?.crm_pid,
        BookingId: editData?.crm_booking_id,
        PaymentTxnId: editData?.payment_txn_id,
        RefundAmount: refund,
        CancelReason: data?.CancelReason,
      };
      dispatch(
        profileAction.refundBookingAction(payload, (res: any) => {
          dispatch(profileAction.orderListAction({}));
          setOpen(false);
          setOpenCancelMsg(true);
          setNotification(true);
        })
      );
    } else {
      dispatch(
        profileAction.cancelBookingAction(data, (res: any) => {
          dispatch(profileAction.orderListAction({}));
          setOpen(false);
          setOpenCancelMsg(true);
          setNotification(true);
        })
      );
    }
  };
  function getDate(date: any) {
    return date ? moment(date).format("DD MMM, YYYY hh:mm:A") : "";
  }
  const handleEditBooking = (details_data: any) => {
    dispatch(cartListResponse([]));
    let detailsData: any = {
      ...details_data?.BookingData,
      CrmBookingData: details_data?.CrmBookingData,
    };
    if (!detailsData?.schedule_date) {
      detailsData.schedule_date = detailsData.CrmBookingData?.lead_preferred_date
        ? moment(detailsData.CrmBookingData?.lead_preferred_date, "DD-MM-YYYY").format("YYYY-MM-DD")
        : "";
    }
    if (!detailsData?.schedule_time) {
      detailsData.schedule_time = detailsData.CrmBookingData?.lead_preferred_time;
    }
    let _cartData: any[] = JSON.parse(detailsData?.updated_order_details || "[]");
    let newCartData: any[] = [];
    _cartData?.forEach((ele: any) => {
      // if(ele?.code !== "G06S07T77"){
      if (!ele?.code.includes("G06S07T")) {
        newCartData.push({
          Id: ele?.code,
          TestCode: ele?.code,
          TestName: ele?.name,
          MRP: ele?.mrp,
          SellingPrice: ele?.selling_price,
          Type: ele?.type,
          Gender: ele?.gender,
        });
      }
    });
    localStorage.setItem("oq:city", details_data?.BookingData.city_id);
    localStorage.setItem("CartData", JSON.stringify(newCartData));
    localStorage.setItem("editBooking", JSON.stringify({ bookingEditData: detailsData, isBookingEdit: true }));
    dispatch(
      setBookingDataResponse({
        tab: "payment",
        bookingEditData: detailsData,
        isBookingEdit: true,
      })
    );
    history.push(ROUTE.CHECKOUT);
  };
  function getStatus(statusData: any) {
    if (statusData?.status == "pending_from_phlebotomist" || statusData?.status_txt == "Phlebotomist Pending") {
      return 2;
    } else if (statusData?.status == "booking_created" || statusData?.status_txt == "Booking Created") {
      return 3;
    } else if (statusData?.status == "sample_collected" || statusData?.status_txt == "Sample collected") {
      return 4;
    } else if (statusData?.status == "Approved" || statusData?.status_txt == "Approved") {
      return 5;
    } else {
      return 0;
    }
  }
  function canCancelBooking(date: any, time: any) {
    if (date && time) {
      time = time?.includes("-") ? `${time?.split("-")[0]}:00` : time;
      let lead = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss");
      let current = lead.diff(moment(), "hours");
      if (current >= 2) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }
  useEffect(() => {
    if (notification) {
      fetchNotifications();
    }
    bookingHistory();
  }, [notification, currentPage]);

  const bookingHistory = () => {
    dispatch(profileAction.orderListAction({ Page: currentPage }));
  };
  const handlePaginationP = (page: number) => {
    // setOffsetP((page - 1) * limit);
    setCurrentPage(page);
  };
  return (
    <>
      <div style={{ position: "relative" }}>
        <div className="tc_box">
          <div className="heading_box">My Bookings</div>
          {commonLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader type="ThreeDots" color="#fff" height={100} width={100} />
            </div>
          ) : (
            <div>
              <div className="order_box_list">
                {orderList?.length > 0 ? (
                  orderList?.map((bookingData: any) => (
                    <div className="order_box" key={bookingData?.CrmData?.id}>
                      <div className="order_summary">
                        <div className="d-flex justify-content-between flex-wrap">
                          <div className="order_name">{bookingData?.CrmData?.patient_name}</div>
                          <div>
                            <span className="mr-2">Booking ID : {bookingData?.CrmData?.id}</span>
                            <span style={{ color: "#C5C4C4" }}>
                              (
                              {bookingData?.CrmData?.created_at
                                ? moment(bookingData?.CrmData?.created_at, "DD-MM-YYYY hh:mm:A").format(
                                    "DD MMM, YYYY hh:mm:A"
                                  )
                                : ""}
                              )
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="middle_order_box">
                        <div className="order_details row align-items-stretch">
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-5">Booking Status</div>
                              <div className="col-7">{bookingData?.CrmData?.status_txt || "-"}</div>
                            </div>
                            <div className="row mt-10">
                              <div className="col-5">Slot Date & Time</div>
                              <div className="col-7">
                                {bookingData?.CrmData?.lead_preferred_date
                                  ? moment(bookingData?.CrmData?.lead_preferred_date)?.format("DD MMM, YYYY")
                                  : ""}{" "}
                                {bookingData?.CrmData?.lead_preferred_time
                                  ? moment(bookingData?.CrmData?.lead_preferred_time, "HH:mm:ss")?.format("hh:mm:A")
                                  : ""}
                              </div>
                            </div>
                            <div className="row mt-10">
                              <div className="col-5">Booking Amount</div>
                              <div className="col-7">
                                ₹
                                {(bookingData?.CrmData.id
                                  ? bookingData?.CrmData?.net_amount
                                  : bookingData?.order_total) || 0}
                              </div>
                            </div>
                            {/* <div className="row mt-10">
                        <div className="col-5"> Advance Paid</div>
                        <div className="col-7">
                          ₹{(bookingData?.id ? bookingData?.advance_paid : bookingData?.CrmData?.net_amount) || 0}
                        </div>
                      </div> */}
                            <div className="row mt-10">
                              <div className="col-5">Booking type</div>
                              <div className="col-7">{formatTextCapitalize(bookingData?.CrmData?.booking_type)}</div>
                            </div>
                          </div>
                          <div className="col-md-6 text-right">
                            <div
                              className="h-100 d-flex flex-column align-items-end justify-content-start mr-2"
                              style={{ gap: "10px" }}
                            >
                              <button
                                type="button"
                                className="book--hexagon active m-0"
                                style={{ width: "220px" }}
                                onClick={() => handleOpenDetail(bookingData)}
                                disabled={actionLoading}
                              >
                                <span className="text-capitalize">
                                  Booking Summary
                                  <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                                </span>
                              </button>
                              {bookingData?.id &&
                                bookingData?.CrmData?.status !== "booking_cancelled" &&
                                bookingData?.CrmData?.status !== "pending_cancellation" &&
                                bookingData?.CrmData?.status !== "cancellation_pending" &&
                                bookingData?.CrmData?.status !== "refund_approved" &&
                                bookingData?.CrmData?.status !== "booking_created" &&
                                bookingData?.CrmData?.status !== "sample_collected" &&
                                bookingData?.CrmData?.status !== "approved" &&
                                canCancelBooking(
                                  bookingData?.CrmData?.lead_preferred_date,
                                  bookingData?.CrmData?.lead_preferred_time
                                ) && (
                                  <button
                                    type="button"
                                    className="book--hexagon red m-0"
                                    style={{ width: "220px" }}
                                    onClick={() => handleOpenCancel(bookingData)}
                                    disabled={actionLoading}
                                  >
                                    <span className="text-capitalize">
                                      Cancel Booking
                                      <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                                    </span>
                                  </button>
                                )}
                              {bookingData?.transactions?.is_refunded?.status === 4 && (
                                <button
                                  type="button"
                                  className="book--hexagon p-2 active m-0"
                                  onClick={() => handleRefundDetailopen(bookingData?.transactions?.payment_id)}
                                  disabled={actionLoading}
                                >
                                  <span className="text-capitalize">
                                    Check refund status
                                    <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
                                  </span>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="timeline">
                        <div className="row justify-content-between align-items-center flex-nowrap">
                          <div
                            className={`col d-flex flex-column align-items-center timeline_box first ${
                              getStatus(bookingData?.CrmData) >= 2 ? "" : "dark"
                            }`}
                          >
                            <div className="t_circle">
                              <span></span>
                            </div>
                            <div className="mt-3">Booking Placed</div>
                          </div>
                          <div
                            className={`col d-flex flex-column align-items-center timeline_box ${
                              getStatus(bookingData?.CrmData) >= 2 ? "" : "dark"
                            }`}
                          >
                            <div className="t_circle">
                              <span></span>
                            </div>
                            <div className="mt-3">Booking Confirmed</div>
                          </div>
                          <div
                            className={`col d-flex flex-column align-items-center timeline_box ${
                              getStatus(bookingData?.CrmData) >= 3 ? "" : "dark"
                            }`}
                          >
                            <div className="t_circle">
                              <span></span>
                            </div>
                            <div className="mt-3">Phlebo Allocated</div>
                          </div>
                          <div
                            className={`col d-flex flex-column align-items-center timeline_box ${
                              getStatus(bookingData?.CrmData) >= 4 ? "" : "dark"
                            }`}
                          >
                            <div className="t_circle">
                              <span></span>
                            </div>
                            <div className="mt-3">Sample Received at Lab</div>
                          </div>
                          <div
                            className={`col d-flex flex-column align-items-center timeline_box ${
                              getStatus(bookingData?.CrmData) >= 5 ? "" : "dark"
                            }`}
                          >
                            <div className="t_circle">
                              <span></span>
                            </div>
                            <div className="mt-3">Report Generated</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="order_box order_summary">
                    <div className="w-100 order_name text-center">No booking found</div>
                  </div>
                )}
              </div>
              {totalOrder?.Count > 0 && (
                <div className="row justify-content-between pb-3">
                  <div className="col-md-3"></div>
                  <div className="col-md-9 d-flex justify-content-end align-items-center">
                    <div className="mr-3 f-14">{`Showing  ${(currentPage - 1) * itemsPerPage + 1} - ${
                      (currentPage - 1) * itemsPerPage + orderList?.length
                    } of ${totalOrder?.Count} Result`}</div>
                    <div className="ml-3">
                      <Pagination
                        onChange={handlePaginationP}
                        current={currentPage}
                        total={totalOrder?.Count || 0}
                        pageSize={itemsPerPage}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        {open && <CancelOrder open={open} editData={editData} handleClose={handleClose} handleSubmit={handleSubmit} />}
        {openDetail && (
          <BookingDetails open={openDetail} handleClose={handleDetailClose} handleEditBooking={handleEditBooking} />
        )}
        {openCancelMsg && <CancelMessage open={openCancelMsg} editData={editData} handleClose={handleCancelMsgClose} />}
        {openRefundDetail && (
          <RefundDetails id={selectedId} open={openRefundDetail} handleClose={handleRefundDetailClose} />
        )}
      </div>
    </>
  );
};

export default MyOrder;
